module.exports = __webpack_public_path__ + "img/arrow-down-ico.ea79f833.svg";